import { FormattedMessage } from 'react-intl';

import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';

import theme from '../../theme';

const ModalButton = ({
  isLoading,
  inputErrorMsg,
  modalContent,
  modalData,
  setModalData,
  handleModalSubmit,
  handleClose,
  colorSystem
}) => {

  const handleModalClose = () => {
    if (modalContent.type === 'custom') {
      handleModalSubmit(modalData, `${modalContent.name}_close`);
    } else {
      handleClose();
    }
  }

  return (
    <>
      <Stack
        variant='center-center'
        sx={{
          paddingTop: '8px',
          paddingBottom: '32px'
        }}
      >
        <Stack>
          {
            modalContent.cancelTxt &&
            <Button
              variant="text-cancel"
              disabled={isLoading !== false ? true : false}
              onClick={handleModalClose}
            >
              {
                modalContent.render === 'locale' ? (
                  <FormattedMessage id={modalContent.cancelTxt} />
                ) : (
                  modalContent.cancelTxt
                )
              }
            </Button>
          }
          {
            modalContent.submitTxt &&
            <Button
              variant="contained"
              disabled={isLoading !== false ? true : false}
              color={modalContent.color?.button ? modalContent.color.button : colorSystem}
              endIcon={isLoading !== false ? <CircularProgress size={16} color="inherit" /> : null}
              onClick={() => handleModalSubmit(modalData, modalContent.name)}
              sx={{
                color: "#fff",
              }}
            >
              {
                modalContent.render === 'locale' ? (
                  <FormattedMessage id={modalContent.submitTxt} />
                ) : (
                  modalContent.submitTxt
                )
              }
            </Button>
          }
        </Stack>
      </Stack>
    </>
  )
}

export default ModalButton;